import React from "react";
import { speakersByTab, type TrackTab } from "../../content/site";
import { SpeakerIdentity } from "./SpeakerIdentity";

type SpeakerCardProps = (typeof speakersByTab)[TrackTab][number];

export function SpeakerCard({ topic, description, note, pending, speakers }: SpeakerCardProps) {
    const primarySpeaker = speakers[0];
    const resolvedNote =
        note ??
        (primarySpeaker?.name === "Борис Харанутов"
            ? "*Roblox заблокирован на территории РФ"
            : undefined);

    if (pending) {
        return (
            <article className="relative flex h-[184px] w-full items-center gap-[20px] overflow-hidden rounded-[40px] bg-black/95 p-[42px] max-lg:h-[128px] max-lg:gap-[60px] max-lg:rounded-[24px] max-lg:p-6">
                <svg
                    aria-hidden="true"
                    viewBox="0 0 1398 184"
                    preserveAspectRatio="none"
                    className="pointer-events-none absolute inset-0 h-full w-full max-lg:hidden"
                >
                    <rect
                        x="0.5"
                        y="0.5"
                        width="1397"
                        height="183"
                        rx="40"
                        fill="none"
                        stroke="#979E96"
                        strokeWidth="1"
                        strokeDasharray="13 13"
                    />
                </svg>
                <svg
                    aria-hidden="true"
                    viewBox="0 0 288 128"
                    preserveAspectRatio="none"
                    className="pointer-events-none absolute inset-0 hidden h-full w-full max-lg:block"
                >
                    <rect
                        x="0.5"
                        y="0.5"
                        width="287"
                        height="127"
                        rx="24"
                        fill="none"
                        stroke="#979E96"
                        strokeWidth="1"
                        strokeDasharray="13 13"
                        strokeLinecap="round"
                    />
                </svg>
                <div className="grid h-[100px] w-[100px] shrink-0 place-items-center rounded-full bg-accent max-lg:h-[80px] max-lg:w-[80px] max-lg:rounded-[1205.96px]">
                    <svg
                        aria-hidden="true"
                        viewBox="0 0 80 80"
                        className="h-[76px] w-[76px]"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <circle cx="40" cy="24" r="12" stroke="black" strokeWidth="6" />
                        <path
                            d="M18 68C18 52.536 27.85 44 40 44C52.15 44 62 52.536 62 68"
                            stroke="black"
                            strokeWidth="6"
                            strokeLinecap="round"
                        />
                    </svg>
                </div>
                <div className="flex min-w-0 max-w-[456px] flex-1 items-center max-lg:max-w-[100px]">
                    <h3 className="text-[28px] leading-none font-bold tracking-[-0.04em] uppercase text-muted max-lg:text-[16px] max-lg:leading-[1]">
                        {primarySpeaker?.name}
                    </h3>
                </div>
            </article>
        );
    }

    return (
        <article className="grid gap-20 rounded-[40px] border border-muted bg-black/95 p-[42px] lg:grid-cols-[538px_1fr] max-lg:gap-4 max-lg:rounded-[24px] max-lg:p-4">
            <div className="flex flex-col gap-8 max-lg:gap-4">
                {speakers.map((speaker, index) => (
                    <SpeakerIdentity
                        key={`${speaker.name ?? "speaker"}-${index}`}
                        name={speaker.name}
                        role={speaker.role}
                        avatar={speaker.avatar}
                    />
                ))}
            </div>
            <div className="flex max-w-[647px] flex-col gap-6 max-lg:gap-3">
                <strong className="text-[24px] leading-none font-bold tracking-[-0.04em] max-lg:text-[20px] max-lg:leading-[1]">
                    {topic}
                </strong>
                {description ? (
                    <p className="m-0 whitespace-pre-line text-[18px] leading-[1.5] font-normal tracking-[-0.04em] text-white max-lg:text-[16px] max-lg:leading-[1.24]">
                        {description}
                    </p>
                ) : null}
                {resolvedNote ? (
                    <p className="m-0 text-[14px] leading-[1.4] font-normal tracking-[-0.02em] text-white/45 max-lg:text-[13px]">
                        {resolvedNote}
                    </p>
                ) : null}
            </div>
        </article>
    );
}
